define('TescoMobile_ClubCard/js/view/deal-tariff',['jquery', 'mage/translate', 'Magento_Catalog/js/price-utils'], function ($, $t, priceUtils) {
  'use strict';

  const mixin = {
    defaults: {
      imports: {
        calculatedDeviceMonthlyPrice: "tm-clubcard-price-provider:calculatedDeviceMonthlyPrice",
        isTariffCcp: "tm-clubcard-price-provider:isTariffsContainClubCardPrice"
      }
    },
    initialize: function () {
      this._super();
      this.calculatedDeviceMonthlyPrice.subscribe(this.initSetDynamicPrice, this);
      this.isTariffCcp.subscribe(this.initSetDynamicPrice, this);
    },
    initObservable: function () {
      this._super().observe(['calculatedDeviceMonthlyPrice', 'pufClubCardPrice', 'isTariffCcp']);
      return this;
    },
    initSetDynamicPrice: function () {
      const tariffOptionRadioSelector = 'input[name="bundle_option[' + this.optionMap.tariff.option_id + ']"]';
      this._setDynamicPrice($(tariffOptionRadioSelector + ':checked'));
    },
    setDynamicPriceForItem: function (item, currentPrice) {
      var _this$deviceMonthlyPr, _this$calculatedDevic;
      const result = this._super(),
        selectionId = item.value,
        clubcardPrice = this._getTariffOptionDataBySelectionId(selectionId, 'clubcard_price'),
        $radioIdLabelPrice = $('label[for="' + item.id + '"] .price'),
        tariffPrice = this._getTariffOptionDataBySelectionId(selectionId, 'price'),
        price = this._getTariffOptionDataBySelectionId(selectionId, 'price') + ((_this$deviceMonthlyPr = this.deviceMonthlyPrice()) !== null && _this$deviceMonthlyPr !== void 0 ? _this$deviceMonthlyPr : 0);
      const finalPrice = parseFloat(tariffPrice + this.calculatedDeviceMonthlyPrice()) < price && !this.isTariffCcp() ? parseFloat(tariffPrice + this.calculatedDeviceMonthlyPrice()) : parseFloat((_this$calculatedDevic = this.calculatedDeviceMonthlyPrice()) !== null && _this$calculatedDevic !== void 0 ? _this$calculatedDevic : 0) + parseFloat(clubcardPrice);
      if (finalPrice) {
        $radioIdLabelPrice.html(`${$radioIdLabelPrice.html()}
<span class="clubcard-price-wrapper">
    <span class="clubcard-price-label">${$t('Clubcard Price')}</span>
    <span class="clubcard-price-value">${$t('<span>%1</span> a month').replace('%1', priceUtils.formatPrice(finalPrice))}</span>
</span>`);
      }
      return result;
    }
  };
  return function (target) {
    return target.extend(mixin);
  };
});

